import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { ActionButtonStyle } from '../../../utils/driveItem';
import { StoreState } from '../../../reducers';
import { DeleteButtonVariants } from './styles';
import { deleteItem, removeAllDownloads, resetAllDownloads } from '../../../containers/DownloadManager/actions';
import UserAgentUtils from '../../../utils/userAgent';
import { Translate } from 'react-redux-i18n';
import DeleteAllPopup from './DeleteAllPopup';

interface DriveItemDeleteButtonProps {
	isDeletingAll: boolean;
	isDownloadingGroup: boolean;
	driveItem?: Api.DriveItem;
	dispatch: Dispatch<StoreState>;
	style: ActionButtonStyle;
}

interface DriveItemDeleteButtonState {
	isPopupDisplayed: boolean;
}

class DriveItemDeleteButton extends React.Component<DriveItemDeleteButtonProps, DriveItemDeleteButtonState> {
	constructor(props: DriveItemDeleteButtonProps) {
		super(props);
		this.state = {
			isPopupDisplayed: false,
		};
		this.handleClick = this.handleClick.bind(this);
		this.renderButtonContent = this.renderButtonContent.bind(this);
		this.handleDeleteSequentially = this.handleDeleteSequentially.bind(this);
		this.handleResetAll = this.handleResetAll.bind(this);
		this.handleCancelPopup = this.handleCancelPopup.bind(this);
	}

	handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		const { driveItem, style, dispatch, isDeletingAll } = this.props;

		e.stopPropagation();
		if (style !== ActionButtonStyle.ParametersPage && driveItem) {
			dispatch(deleteItem(driveItem));
		} else if (style === ActionButtonStyle.ParametersPage && !isDeletingAll) {
			this.setState({ isPopupDisplayed: true });
		}
	}

	handleDeleteSequentially = () => {
		const { dispatch } = this.props;
		this.setState({ isPopupDisplayed: false });
		dispatch(removeAllDownloads());
	}

	handleResetAll = () => {
		const { dispatch } = this.props;
		this.setState({ isPopupDisplayed: false });
		dispatch(resetAllDownloads());
	}

	handleCancelPopup = () => {
		this.setState({ isPopupDisplayed: false });
	}

	renderButtonContent = () => {
		const { style, isDeletingAll } = this.props;

		const isPhone = UserAgentUtils.isPhone();

		if (style === ActionButtonStyle.Bar && !isPhone) {
			return <Translate value="messages.delete" />;
		} else if (style === ActionButtonStyle.Icon || (style === ActionButtonStyle.Bar && isPhone)) {
			return Utils.getSvgIcon('iconset_uprez_delete');
		} else if (style === ActionButtonStyle.ParametersPage) {
			return (
				<div>
					{isDeletingAll && Utils.getSvgIcon('iconset_loading')}
					<Translate value="messages.delete_data" />
				</div>
			);
		} else {
			return;
		}
	}

	render() {
		const { style, isDownloadingGroup, isDeletingAll } = this.props;
		const { isPopupDisplayed } = this.state;
		const DeleteButton = DeleteButtonVariants[style];
		const isDisabled = style === ActionButtonStyle.ParametersPage && isDownloadingGroup;

		return (
			<>
			<DeleteButton onClick={this.handleClick} disabled={isDisabled}>
				{this.renderButtonContent()}
			</DeleteButton>
				{style === ActionButtonStyle.ParametersPage && (
					<DeleteAllPopup
						isDisplayed={isPopupDisplayed}
						onDeleteSequentially={this.handleDeleteSequentially}
						onResetAll={this.handleResetAll}
						onCancel={this.handleCancelPopup}
						isProcessing={isDeletingAll}
					/>
				)}
			</>
		);
	}
}

export default DriveItemDeleteButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DeleteButton/index.tsx